<template>
  <div class="flex flex-col items-start">
    <h1 class="text-info text-sm">{{ title }}</h1>
    <p class="text-white font-bold text-base">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "RewardText",
  props: {
    title: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
  },
};
</script>
